import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function BrandVerification() {
    const {
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const legalForm = details.legal_form;

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    const isCommercial = [
        "legal.llc",
        "legal.ltd",
        "legal.inc",
        "legal.corp",
        "legal.sarl",
        "legal.sa",
        "legal.sas",
        "legal.holding",
        "legal.partnership",
    ].includes(legalForm);

    const isInstitutional = [
        "legal.association",
        "legal.foundation",
        "legal.institution",
    ].includes(legalForm);

    const isOwner =
        legalForm === "legal.sole";

    const getMessage = () => {

        if (isCommercial) {
            return {
                title: t("brandVerification.legalTitle"),
                text: t("brandVerification.companyText")
            };
        }

        if (isInstitutional) {
            return {
                title: t("brandVerification.legalTitle"),
                text: t("brandVerification.institutionText")
            };
        }

        return {
            title: t("brandVerification.activityTitle"),
            text: t("brandVerification.ownerText")
        };
    };

    const message = getMessage();

    return (
        <div className="verification-wrapper">
            <VerificationInfo
                title={message.title}
                text={message.text}
            />

            <div className="verification-content">

                {isCommercial && (
                    <UploadBox
                    label={t("brandVerification.tradeRegister")}
                        name="brand_rc"
                        file={verificationData.brand_rc}
                        onChange={handleFile}
                    />
                )}

                {isInstitutional && (
                    <UploadBox
                    label={t("brandVerification.officialStatus")}
                        name="brand_statuts"
                        file={
                            verificationData.brand_statuts
                        }
                        onChange={handleFile}
                    />
                )}

                {isOwner && (
                    <>
                        <UploadBox
                            label={t("brandVerification.identity")}
                            name="own_id"
                            file={verificationData.own_id}
                            onChange={handleFile}
                        />

                        <UploadBox
                            label={t("brandVerification.registration")}
                            name="brand_registration"
                            file={
                                verificationData.brand_registration
                            }
                            onChange={handleFile}
                        />
                    </>
                )}

            </div>

            <PrivacyNotice />
        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();

    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                ✓ {t("brandVerification.carrerupVerification")}
            </div>

            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {

    const { t } = useTranslation();

    return (
        <div className="verification-privacy">
            🔒 {t("brandVerification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}